import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format minutes as a human-readable duration string.
 * Examples: 0 -> "0h", 30 -> "30m", 60 -> "1h", 90 -> "1h 30m"
 */
export function formatDuration(minutes: number): string {
  if (minutes === 0) return '0h'

  const hours = Math.floor(minutes / 60)
  const remaining = minutes % 60

  if (hours > 0 && remaining > 0) return `${hours}h ${remaining}m`
  if (hours > 0) return `${hours}h`
  return `${remaining}m`
}
